<template>
    <FileDropper></FileDropper>
</template>

<script>
import { defineAsyncComponent } from "vue";

const AuthLayout = defineAsyncComponent(() =>
    import("../../Layouts/AuthLayout.vue")
);
const FileDropper = defineAsyncComponent(() =>
    import("../../components/Engineering/FileDropper.vue")
);

export default {
    name: "File_Dropper", //The name you are in should not equal the name of the component you are importing.
    components: { FileDropper, AuthLayout },
};
</script>
